import { Breadcrumb, Button, PageHeader } from 'antd';
import { FC, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import OrderFilter from '../components/filters/order-filter';
import OrdersTable from '../components/tables/orders-table';
import OrderStatus from '../components/widgets/order-status';

const OrdersListRoute: FC = () => {
  const [filters, setFitlers] = useState()
  const navigate = useNavigate()

  return (<>
    <PageHeader
      title="سفارشات"
      style={{ padding: " 16px 0" }}
      onBack={() => navigate(-1)}

    />
    <div style={{ marginBottom: "16px" }}>
      <OrderStatus />

    </div>
    <OrderFilter onFinish={setFitlers} />
    <OrdersTable filters={filters} />
  </>);
}

export default OrdersListRoute;
